import { Button, Divider, ListItemIcon, ListItemText, MenuItem, Typography } from "@mui/material";
import { useContext, useState } from "react";
import Avatar from '../avatar'
import MenuElevation from "../menuElevation";
import MenuItemLogout from "../menuElevation/menuItemLogout";
import AvatarHeader from "./avatarHeader";
import React from 'react';
import { AuthContext } from "../../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

export default function MenuElevationHeader({ ...props }) {

    const [anchorEl, setAnchorEl] = useState(null);
    const navigate = useNavigate()
    const openMenu = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const { user } = useContext(AuthContext)

    return (
        <>
            <AvatarHeader
                onClick={handleClick}
                aria-controls={openMenu ? 'account-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={openMenu ? 'true' : undefined}>

            </AvatarHeader>
            <MenuElevation
                id="account-menu" anchorEl={anchorEl} open={openMenu} onClose={handleClose} onClick={handleClose}
                {...props}
            >
                <MenuItem >
                    <ListItemText sx={{ color: "#2c4992", fontWeight: "bold" }}>{user?.name_client}</ListItemText>
                </MenuItem>
                <MenuItem >
                    <ListItemText sx={{ fontSize: "0.7rem" }}>{user?.name}</ListItemText>
                    <ListItemIcon>
                        <Button onClick={() => navigate('/profile')} sx={{ color: "#000", textTransform: "initial" }}>
                            Editar
                        </Button>
                    </ListItemIcon>
                </MenuItem>
                <MenuItem>
                    <ListItemText sx={{ fontSize: "0.7rem" }}>{user?.email}</ListItemText>
                </MenuItem>
                <MenuItem onClick={() => navigate('/editPassword')}>
                    <ListItemText sx={{ fontSize: "0.7rem",  textDecoration: "underline", color: "#2c4992" }}>Trocar Senha</ListItemText>
                </MenuItem>
                <Divider />
                <MenuItemLogout />
            </MenuElevation >
        </>
    )
}